























import { Component, Vue, Prop } from 'vue-property-decorator';
import { JobServiceForm } from '@/models/jobServiceForm/jobServiceForm';
import { JobServiceFormRequest } from '@/models/jobServiceForm/jobServiceFormRequest';
import OptionSelector from '@/components/common/OptionSelector.vue';
import Nullable from '@/types/nullable';

@Component({
  components: {
    OptionSelector
  }
})
export default class PersonalProtectiveEquipmentForm extends Vue {
  @Prop({ type: Object, default: null }) public data!: JobServiceFormRequest;
  @Prop({ type: Object, default: null }) public loadedForm!: Nullable<JobServiceForm>;
  private expanded: boolean = false;

  get ppeOptions(){
    return [
      {
        id: 1,
        name: "Foot Protection"
      },
      {
        id: 2,
        name: "Hand Protection"
      },
      {
        id: 3,
        name: "High Visibility Clothing"
      },
      {
        id: 4,
        name: "Breathing Protection"
      },
      {
        id: 5,
        name: "Eye Protection"
      }
    ];
  }
}

